var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: _vm.dialogVisible, width: "40%" },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "120px"
          }
        },
        [
          _vm._t("tip"),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _vm.isEmail
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: this.$t("company.email") } },
                          [
                            _c("el-input", {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.formData.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "email", $$v)
                                },
                                expression: "formData.email"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "el-form-item",
                          { attrs: { label: this.$t("company.phone") } },
                          [
                            _c("el-input", {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.formData.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "phone", $$v)
                                },
                                expression: "formData.phone"
                              }
                            })
                          ],
                          1
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.isChange
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.isChange },
                          on: {
                            click: function($event) {
                              return _vm.changeWay(_vm.isEmail)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("developer.changeWay")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("developer.code"), prop: "code" }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formData.code,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "code", $$v)
                          },
                          expression: "formData.code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("timing", {
                    ref: "timing",
                    attrs: { status: true, isShow: true },
                    on: { toGetCode: _vm.getEmailCode }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("common.cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v(_vm._s(_vm.$t("common.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-379a6e09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-379a6e09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/verify.vue
// module id = null
// module chunks = 